module.exports = __webpack_public_path__ + "img/PL08166.eefdeb1e.png";